export class RecrutiationSource {
    redirectCandidateUrl: string;
    name: string;
    externalRecruitmentUrl: string;
    formName: string;
    recruitmentSourceName: string;
    recruitmentProjectId: number;
    recruitmentProjectName: string;
    isActive: boolean;
    guid?: string;
  }